import React, {FC} from 'react';
import {connect} from 'react-redux';

import {makeGetContactsManagerParameters} from '../../../../../../../src/store/panels/contacts/contactsManager/contactsManagerPanelSelectors';
import {
  ContactsManagerParameters,
  ContactsManagerParametersTypesEnum,
} from '../../../../../../../src/store/panels/contacts/contactsManager/parameters/contactsManagerParameters';
import {ContactsManagerPanelId} from '../../../../../../../src/store/panels/panelStateBase';
import {makeMapStateToProps} from '../../../../../../../srcCommon/helpers/reselectHelpers';
import {usePrevious} from '../../../../../../shared/helpers/src/react/hooks/hookHelpers';
import {useContactsManagerContext} from '../contactsManagerContext';
import {AccountContactsPageContainer} from './accountContactsPageContainer';
import {AccountsCsvImportContainer} from './accounts/accountsCsvImport/accountsCsvImportContainer';
import {AccountsPageContainer} from './accountsPageContainer';
import {CardGroupContactsPageContainer} from './cardGroupContactsPageContainer';
import {CardGroupsPageContainer} from './cardGroupsPageContainer';
import {ContactsPageContainer} from './contacts/contactsPageContainer';
import {CrmSyncsPageContainer} from './crmSyncs/crmSyncsPageContainer';
import {SearchPageContainer} from './search/searchPageContainer';

/*
 * Props.
 */

interface PageRoutingContainerProps {
  panelId: ContactsManagerPanelId;
}

interface PageRoutingContainerComponentProps {
  parameters: ContactsManagerParameters;
}

/*
 * Component.
 */

const PageRoutingContainerComponent: FC<PageRoutingContainerComponentProps> = (props) => {
  const {parameters} = props;
  const {panelId} = useContactsManagerContext();
  const previousParameters = usePrevious(parameters);

  switch (parameters.type) {
    case ContactsManagerParametersTypesEnum.LISTS:
      return <CardGroupsPageContainer />;
    case ContactsManagerParametersTypesEnum.LIST_CONTACTS:
      return <CardGroupContactsPageContainer />;
    case ContactsManagerParametersTypesEnum.SHARED_CONTACTS:
    case ContactsManagerParametersTypesEnum.PRIVATE_CONTACTS:
    case ContactsManagerParametersTypesEnum.AUTO_CONTACTS:
      return <ContactsPageContainer panelId={panelId} contactsRouteType={parameters.type} />;
    case ContactsManagerParametersTypesEnum.SEARCH:
      return <SearchPageContainer panelId={panelId} />;
    case ContactsManagerParametersTypesEnum.ACCOUNT_CONTACTS:
      return <AccountContactsPageContainer panelId={panelId} />;
    case ContactsManagerParametersTypesEnum.SYNCS:
      return (
        <CrmSyncsPageContainer
          panelId={panelId}
          isOnErrorsPage={Boolean(parameters.shouldShowErrors)}
          source={parameters.source}
          previousPageType={previousParameters?.type}
        />
      );
    case ContactsManagerParametersTypesEnum.ACCOUNT_SYNCS:
      return (
        <AccountsPageContainer panelId={panelId} shouldShowCrmSyncErrors={parameters.shouldShowErrors} />
      );
    case ContactsManagerParametersTypesEnum.ACCOUNTS_CSV_IMPORT:
      return <AccountsCsvImportContainer panelId={panelId} />;
    case ContactsManagerParametersTypesEnum.ACCOUNTS:
    default:
      return <AccountsPageContainer panelId={panelId} />;
  }
};

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<PageRoutingContainerProps>()(() => ({
  parameters: makeGetContactsManagerParameters(),
}));

export const PageRoutingContainer = connect(mapStateToProps)(PageRoutingContainerComponent);
